module.exports = __webpack_public_path__ + "img/lite-pool-3.59f5897c.jpg";